module.exports = __webpack_public_path__ + "static/media/gm.5897a085.svg";